import React from "react";
import { FaEdit } from "react-icons/fa";

const UserTable = ({ users, roles, page, itemsPerPage, onEdit }) => {
  const getRoleName = (roleId) => {
    const role = roles.find((r) => r.id === roleId);
    return role ? role.name : "Unknown";
  };

  return (
    <div className="card">
      <table className="roles-table">
        <thead>
          <tr>
            <th style={{ width: "80px" }}>SI.NO</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th className="actions-col" style={{ width: "100px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user, i) => (
              <tr key={user.id || i}>
                <td>{(page - 1) * itemsPerPage + i + 1}</td>
                <td className="role-name">{user.username || user.name || "—"}</td>
                <td className="email">{user.invitedEmail}</td>
                <td>
                  <span className="role-badge">
                    {getRoleName(user.roleId)}
                  </span>
                </td>
                <td className="actions-col" style={{ textAlign: "center" }}>
                  <button 
                    className="btn-icon" 
                    title="Edit User"
                    onClick={() => onEdit(user)}
                  >
                    <FaEdit size={16} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="empty-state">
                <h3>No users found</h3>
                <p>Invite users to your workspace to see them here.</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
